import {createSelector} from 'reselect';
import {getSelectedPaymentOption} from '../selectors';

export default createSelector(
  [getSelectedPaymentOption],
  (selectedPaymentOption) => {
    const selectedPaymentOptionType = selectedPaymentOption?.type?.toLowerCase();
  
    if (selectedPaymentOption?.isOpttyOption) {
      return `Optty_${selectedPaymentOptionType}`;
    }
    
    if (selectedPaymentOption?.isAdyenV2Option) {
      return `AdyenV2_${selectedPaymentOptionType}`;
    }
    
    return selectedPaymentOptionType;
  },
);
